/* eslint-disable no-undef */
import englishMessages from 'cw-core-admin-ui/src/i18n/en';

const coreResources = englishMessages.resources;
const demoWalletResources = {
	purchases: {
		name: 'Purchases',
		fields: {
			id: 'ID',
			creationDateTime: 'Created',
			shopConfigurationId: 'Shop Configuration',
			purchaseType: 'Type',
			purchaseStatus: 'Status',
			consumerAmount: 'Consumer Amount',
			refundedAmount: 'Refunded Amount',
			consumerWalletId: 'Consumer Wallet',
			consumerWalletAccountId: 'Consumer Wallet Account',
			description: 'Description',
			customType: 'Custom Type',
			refundedAmountLC: 'Refunded Amount (LC)',
			loyaltyCreditAmount: 'Loyalty Credit Amount',
			loyaltyCreditAmountLC: 'Loyalty Credit Amount (LC)',
			consumerExchangeRate: 'Exchange Rate',
			consumerLoyaltyCreditAmount: 'Loyalty Credit Amount',
			consumerRefundedAmount: 'Refunded Amount',
			walletAccountId: 'Merchant Wallet Account',
			walletId: 'Merchant Wallet',
			merchantAmount: 'Amount',
			merchantExchangeRate: 'Exchange Rate',
			merchantLoyaltyCreditAmount: 'Loyalty Credit Amount',
			merchantRefundedAmount: 'Refunded Amount',
			firstName: 'First name',
			lastName: 'Last name',
			emailAddress: 'Email',
			redirectUrl: 'Redirect URL',
			shopReturnUrl: 'Shop Return URL',
			purchaseSettlementStatus: 'Settlement Status',
			manualSettlementComment: 'Manual Settlement Comment',
		},
		filter: {
			shopConfigurationId: 'Shop Configuration',
			purchaseType: 'Type',
			purchaseStatus: 'Status',
			fromDate: 'From',
			untilDate: 'Until',
		},
	},
	shopConfigurations: {
		name: 'Shop Configurations',
		fields: {
			shopConfigurationId: 'ID',
			creationDateTime: 'Created',
			shopConfigurationStatus: 'Status',
			name: 'Name',
			currencyCode: 'Currency',
			shopCategoryCode: 'Category Code',
			walletAccountId: 'Wallet Account',
			customType: 'Custom Type',
			notificationUrl: 'Notification URL',
			returnUrl: 'Return URL',
			logoUrl: 'Logo URL',
		},
		filter: {
			walletId: 'Wallet ID',
			walletAccountId: 'Wallet Account ID',
			shopConfigurationStatus: 'Status',
		},
		actions: {
			activate: 'Activate',
			lock: 'Lock',
		},
		notifications: {
			successfullyUpdated: 'Shop configuration successfully updated!',
		},
	},
	loyaltyPrograms: {
		name: 'Loyalty Programs',
		fields: {
			id: 'ID',
			creationDateTime: 'Created',
			loyaltyProgramStatus: 'Status',
			name: 'Name',
			owner: 'Shop Configuration',
			ownerType: 'OwnerType',
			ownerId: 'Shop Configuration ID',
			amount: {
				amount: 'Amount',
				currency: 'Currency',
			},
			loyaltyPercentage: 'Loyalty Percentage',
			walletAccountItemId: 'Wallet account item',
		},
		filter: {
			walletId: 'Wallet ID',
			ownerType: 'Owner Type',
			ownerId: 'Shop Configuration ID',
			status: 'Status',
			fromDate: 'From',
			untilDate: 'Until',
		},
		actions: {
			activate: 'Activate',
			lock: 'Lock',
			delete: 'Delete',
		},
		notifications: {
			successfullyUpdated: 'Loyalty Program successfully updated!',
			successfullyDeleted: 'Loyalty Program successfully deleted.',
		},
	},
	loyaltyProgramMemberships: {
		name: 'Loyalty Program Memberships',
		fields: {
			id: 'ID',
			creationDateTime: 'Created',
			loyaltyProgramId: 'Loyalty Program ID',
			walletId: 'Customer Wallet ID',
			walletAccountId: 'Loyalty Member Wallet Account ID',
			creator: {
				type: 'Creator Type',
				id: 'Creator ID',
			},
		},
		filter: {
			walletId: 'Customer Wallet ID',
			fromDate: 'From',
			untilDate: 'Until',
		},
	},
	loyaltyCredits: {
		name: 'Loyalty Credits',
		fields: {
			id: 'ID',
			creationDateTime: 'Created',
			loyaltyProgramId: 'Loyalty Program ID',
			loyaltyProgramMembershipId: 'Loyalty Program Membership ID',
			owner: {
				type: 'Creator Type',
				id: 'Creator ID',
			},
			amount: {
				currency: 'Loyalty Credit Currency',
				amount: 'Loyalty Credit Amount',
			},
			cancelledAmount: {
				currency: 'Cancelled Currency',
				amount: 'Cancelled Amount',
			},
			loyaltyCreditAction: 'Action',
			loyaltyCreditStatus: 'Status',
			referencedLoyaltyCreditId: 'Referenced Loyalty Credit ID',
			customerWalletAccountItemId: 'Loyalty Member Wallet Account Item ID',
			programWalletAccountItemId: 'Loyalty Program Account Item ID',
		},
		filter: {
			loyaltyProgramId: 'Loyalty Program ID',
			loyaltyProgramMembershipId: 'Loyalty Program Membership ID',
			ownerType: 'Owner Type',
			ownerId: 'Owner ID',
			action: 'Action',
			status: 'Status',
			fromDate: 'From',
			untilDate: 'Until',
		},
	},
	marketplaces: {
		name: 'Marketplaces',
		fields: {
			id: 'ID',
			walletId: 'Wallet ID',
			name: 'Name',
			status: 'Status',
			creationDateTime: 'Created',
			authorizations: 'Authorizations',
		},
		filter: {
			id: 'ID',
			walletId: 'Wallet ID',
			name: 'Name',
			status: 'Status',
		},
		actions: {
			activate: 'Activate',
			lock: 'Lock',
			delete: 'Delete',
		},
		notifications: {
			successfullyUpdated: 'Marketplace successfully updated!',
			successfullyDeleted: 'Marketplace successfully deleted!',
		},
	},
	marketplaceSellers: {
		name: 'Marketplace Sellers',
		fields: {
			id: 'ID',
			externalId: 'External ID',
			marketplaceId: 'Marketplace',
			shopConfigurationId: 'Shop Configuration ID',
			name: 'Name',
			status: 'Status',
			creationDateTime: 'Created',
		},
		filter: {
			externalId: 'External ID',
			marketplaceId: 'Marketplace ID',
			shopConfigurationId: 'Shop Configuration ID',
			name: 'Name',
			status: 'Status',
		},
		actions: {
			activate: 'Activate',
			lock: 'Lock',
			delete: 'Delete',
		},
		notifications: {
			successfullyUpdated: 'Marketplace seller successfully updated!',
			successfullyDeleted: 'Marketplace seller successfully deleted!',
		},
	},
	marketplacePurchases: {
		name: 'Marketplace Purchases',
		fields: {
			id: 'ID',
			creationDateTime: 'Created',
			marketplaceId: 'Marketplace ID',
			purchaseType: 'Type',
			purchaseStatus: 'Status',
			consumerAmount: 'Consumer Amount',
			consumerWalletId: 'Consumer Wallet ID',
			consumerWalletAccountId: 'Consumer Wallet Account ID',
			description: 'Description',
			firstName: 'First name',
			lastName: 'Last name',
			emailAddress: 'Email',
			redirectUrl: 'Redirect URL',
			purchaseSettlementStatus: 'Settlement Status',
			manualSettlementComment: 'Manual Settlement Comment',
			sellers: 'Marketplace Purchase Sellers',
		},
		filter: {
			marketplaceId: 'Marketplace',
			consumerWalletAccountId: 'Consumer Wallet Account ID',
			purchaseStatus: 'Status',
			emailAddress: 'Email',
			fromDate: 'From',
			untilDate: 'Until',
		},
	},
	invoiceVouchers: {
		name: 'InvoiceVouchers',
		fields: {
			id: 'ID',
			voucherCode: 'Voucher Code',
			voucherAmount: 'Voucher Amount',
			marketingAction: 'Marketing Action',
			description: 'Description',
			status: 'Status',
			activate: 'Activate',
			creationDateTime: 'Created At',
		},
		filter: {
			amountFrom: 'Amount From',
			amountTo: 'Amount To',
			voucherStates: 'Voucher States',
			marketingActions: 'Marketing Actions',
			currency: 'Currency',
		},
		actions: {
			lock: 'Lock',
			unlock: 'Unlock',
			redeem: 'Redeem',
			activate: 'Activate',
			cancel: 'Cancel',
		},
		notifications: {
			canceled: 'The voucher is now canceled.',
			activated: 'The voucher is now activated.',
			locked: 'The voucher was successfully locked.',
			unlocked: 'The voucher was successfully unlocked.',
			successfullyUpdated: 'The Voucher successfully updated!',
		},
	},
};
const demoWalletAdmin = {
	menu: {
		marketplaces: 'Marketplace',
	},
};
const resources = {
	...coreResources,
	...demoWalletResources,
	...demoWalletAdmin,
};
export default {
	...englishMessages,
	resources,
};
